// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__20jlM","label":"Checkbox_label__2R9H7","checkbox":"Checkbox_checkbox__2DiPf"};